// extracted by mini-css-extract-plugin
export default {"stack":"CreateItem_stack__3Etjl","form":"CreateItem_form__cQeYT","heading":"CreateItem_heading__DiOcS"};